import "./WistiaEmbedVideoComponent.scss";

import {IComponentOptions} from "angular";
import template from "./WistiaEmbedVideoComponent.html";

export const WistiaEmbedVideo = "tfWistiaEmbedVideo";

export function wistiaEmbedVideo(): IComponentOptions {
    return {
        template,
        bindings: {
            videoId: "@"
        },
        controllerAs: "ctrl",
        controller: WistiaEmbedVideoComponentController
    };
}

export class WistiaEmbedVideoComponentController {
    public videoId: string;
}
